// Copyright (c) 2017 Deere & Company

import SearchFilters from '../state/search-filters';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateListFilterBy = (state, action) =>
    SearchFilters.update(state, {
        filterBy: {
            $set: action.filterBy
        }
    });

const updateListSortBy = (state, action) =>
    SearchFilters.update(state, {
        sortBy: {
            $set: action.sortBy
        }
    });

const updateListSortDirection = (state, action) =>
    SearchFilters.update(state, {
        sortDirection: {
            $set: action.sortDirection
        }
    });

export default (state = getDefaultState().searchFilters, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_AUDIT_CLAIM_FILTER_BY]: updateListFilterBy,
        [actions.UPDATE_TCSM_AUDIT_CLAIM_SORT_BY]: updateListSortBy,
        [actions.UPDATE_TCSM_AUDIT_CLAIM_SORT_DIRECTION]: updateListSortDirection
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};




// WEBPACK FOOTER //
// ./src/tcsm/claim-search/reducers/search-filters.js